import { render } from "./VehiclesPage.vue?vue&type=template&id=35a106b7&scoped=true"
import script from "./VehiclesPage.vue?vue&type=script&lang=js"
export * from "./VehiclesPage.vue?vue&type=script&lang=js"

import "./VehiclesPage.vue?vue&type=style&index=0&id=35a106b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a106b7"]])

export default __exports__